/* 9MILLY - poradnik rozmiarów.
   1) Strona /pages/rozmiary: zakładki + podświetlanie kolumny.
   2) Karta produktu: kliknięcie "Poradnik rozmiarów" otwiera szklane okno na
      tej samej stronie (klient nie wychodzi z produktu). Treść okna to ta sama
      tabela co na stronie /pages/rozmiary (pobierana raz i cache'owana), więc
      wymiary edytuje się w jednym miejscu: w edytorze motywu, na stronie
      "Rozmiary". Bez JS link po prostu prowadzi na stronę. */

if (!window.__nmSizeGuide) {
  window.__nmSizeGuide = true;

  const PAGE_SELECTOR = '.nm-size__panel';

  function initRoot(root, startKey) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';

    const tabs = [...root.querySelectorAll('.nm-size__tab')];
    const panels = [...root.querySelectorAll('.nm-size__panelbody')];

    const select = (key, focus = false, updateHash = false) => {
      let found = false;
      tabs.forEach((tab) => {
        const on = tab.dataset.key === key;
        if (on) found = true;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      if (!found) return;
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.key !== key;
      });
      if (updateHash && root.hasAttribute('data-nm-size-page') && window.history?.replaceState) {
        window.history.replaceState(null, '', `#${key}`);
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.key, false, true));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          event.preventDefault();
          select(next.dataset.key, true, true);
        }
      });
    });

    root.addEventListener('click', (event) => {
      const cell = event.target instanceof Element ? event.target.closest('th[data-col], td[data-col]') : null;
      if (!cell) return;
      const table = cell.closest('table');
      if (!table) return;
      const col = cell.dataset.col;
      const already = table.dataset.active === col;
      table.dataset.active = already ? '' : col;
      table.querySelectorAll('[data-col]').forEach((node) => {
        node.classList.toggle('is-active', !already && node.dataset.col === col);
      });
    });

    if (startKey) select(startKey);
  }

  /* ---------------- strona rozmiarów ---------------- */

  function initPage() {
    document.querySelectorAll('[data-nm-size-page]').forEach((root) => {
      const hash = (window.location.hash || '').replace('#', '');
      initRoot(root, hash);
      window.addEventListener('hashchange', () => {
        const key = (window.location.hash || '').replace('#', '');
        const tab = root.querySelector(`.nm-size__tab[data-key="${CSS.escape(key)}"]`);
        if (tab) tab.click();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage);
  else initPage();

  /* ---------------- okno na karcie produktu ---------------- */

  let dialog = null;
  let pageFragment = null;
  let pagePromise = null;

  function loadPage(url) {
    if (!pagePromise) {
      pagePromise = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('size page');
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const panel = doc.querySelector(PAGE_SELECTOR);
          if (!panel) throw new Error('size panel missing');
          panel.querySelector('.nm-size__head')?.remove();
          panel.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          panel.querySelectorAll('[aria-controls],[aria-labelledby]').forEach((node) => {
            node.removeAttribute('aria-controls');
            node.removeAttribute('aria-labelledby');
          });
          pageFragment = panel;
          return panel;
        })
        .catch((error) => {
          pagePromise = null;
          throw error;
        });
    }
    return pagePromise;
  }

  function buildDialog() {
    const el = document.createElement('dialog');
    el.className = 'nm-sizemodal';
    el.setAttribute('aria-label', 'Poradnik rozmiarów');
    el.innerHTML = `
      <div class="nm-sizemodal__card">
        <div class="nm-sizemodal__top">
          <p class="nm-sizemodal__title">Poradnik rozmiarów</p>
          <button type="button" class="nm-sizemodal__close" aria-label="Zamknij">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M4 4l10 10M14 4L4 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
          </button>
        </div>
        <div class="nm-sizemodal__body" data-nm-size></div>
      </div>`;
    document.body.appendChild(el);

    el.addEventListener('click', (event) => {
      if (event.target === el || (event.target instanceof Element && event.target.closest('.nm-sizemodal__close'))) el.close();
    });
    el.addEventListener('close', () => document.documentElement.classList.remove('nm-sizemodal-open'));
    return el;
  }

  async function openModal(link) {
    const href = link.getAttribute('href') || '';
    const url = href.split('#')[0];
    const key = link.dataset.key || href.split('#')[1] || '';

    if (!dialog) dialog = buildDialog();
    const title = link.querySelector('.nm-sizelink__cta')?.textContent.trim();
    if (title) {
      dialog.setAttribute('aria-label', title);
      dialog.querySelector('.nm-sizemodal__title').textContent = title;
    }
    const body = dialog.querySelector('.nm-sizemodal__body');
    if (!dialog.open) {
      document.documentElement.classList.add('nm-sizemodal-open');
      dialog.showModal();
    }

    if (!body.firstElementChild) body.innerHTML = '<p class="nm-sizemodal__loading">Ładuję tabelę…</p>';

    try {
      const panel = await loadPage(url);
      if (!body.querySelector('.nm-size__panel')) {
        body.innerHTML = '';
        body.appendChild(document.importNode(panel, true));
        body.dataset.ready = '';
        initRoot(body, key);
      } else {
        const tab = body.querySelector(`.nm-size__tab[data-key="${CSS.escape(key)}"]`);
        if (tab) tab.click();
      }
    } catch (error) {
      dialog.close();
      window.location.href = href;
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-nm-size-open]') : null;
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
    event.preventDefault();
    openModal(link);
  });

  // Wstępne pobranie tabeli, gdy klient zbliża się do linku - okno otwiera się od razu.
  const warm = (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-nm-size-open]') : null;
    if (link && !pageFragment) loadPage((link.getAttribute('href') || '').split('#')[0]).catch(() => {});
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
}
